import React from 'react';
import styled from 'styled-components';
import useTheme from '../hooks/useTheme.ts';
import { FiSun, FiMoon } from 'react-icons/fi';

interface ThemeToggleProps {
  className?: string;
}

const ToggleButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  min-width: 32px;
  min-height: 32px;
  padding: 0;
  border-radius: var(--radius-md, 6px);
  background-color: transparent;
  color: var(--color-text);
  border: 1px solid var(--color-border);
  cursor: pointer;
  transition: background-color var(--transition-normal), color var(--transition-normal),
    border-color var(--transition-normal);

  &:hover {
    background-color: var(--color-table-row-hover);
    border-color: var(--color-text-muted, var(--color-border));
  }

  &:focus-visible {
    outline: 2px solid var(--color-green, var(--color-primary));
    outline-offset: 2px;
  }

  svg {
    font-size: 18px;
    flex-shrink: 0;
  }
`;

const ThemeToggle: React.FC<ThemeToggleProps> = ({ className }) => {
  const { theme, toggleTheme } = useTheme();

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    toggleTheme();
  };

  const nextIsDark = theme === 'light';

  return (
    <ToggleButton
      type="button"
      onClick={handleClick}
      className={className}
      aria-label={nextIsDark ? 'Switch to dark mode' : 'Switch to light mode'}
    >
      {theme === 'light' ? <FiMoon /> : <FiSun />}
    </ToggleButton>
  );
};

export default ThemeToggle;
